import React, { useState } from "react";
import { ShieldCheck, Loader2, Mail, Smartphone, LogOut } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export default function MfaGate() {
  const { user, setUser, logout } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [demoCode, setDemoCode] = useState(sessionStorage.getItem("mfa_demo_code") || "");
  const method = user?.two_factor_method || "email";

  const verify = async () => {
    if (code.trim().length !== 6) { toast.error("Entrez le code à 6 chiffres"); return; }
    setBusy(true);
    try {
      const res = await api.post("/auth/2fa/verify", { code: code.trim() });
      sessionStorage.removeItem("mfa_demo_code");
      setUser(res.data);
      toast.success("Connexion sécurisée validée");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Code incorrect");
      setBusy(false);
    }
  };

  const resend = async () => {
    try {
      const res = await api.post("/auth/2fa/resend");
      if (res.data.demo_code) {
        sessionStorage.setItem("mfa_demo_code", res.data.demo_code);
        setDemoCode(res.data.demo_code);
      }
      toast.success("Nouveau code envoyé");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };

  const MethodIcon = method === "sms" ? Smartphone : Mail;

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-softer p-4" data-testid="mfa-gate">
      <div className="max-w-md w-full bg-white rounded-3xl border border-brand-soft p-8 text-center">
        <div className="w-14 h-14 rounded-2xl mx-auto bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center">
          <ShieldCheck className="w-7 h-7" />
        </div>
        <h1 className="font-display text-2xl font-semibold text-brand-greenDeep mt-5">Connexion sécurisée</h1>
        <p className="text-sm text-brand-green/60 mt-2 inline-flex items-center gap-1.5 justify-center">
          <MethodIcon className="w-4 h-4" />
          Un code de vérification vous a été envoyé par {method === "sms" ? "SMS" : "email"}.
        </p>

        {demoCode && (
          <div className="mt-4 rounded-2xl bg-brand-lime/15 border border-brand-lime/40 px-4 py-3" data-testid="mfa-demo-code">
            <p className="text-xs font-semibold text-brand-greenDeep/70 uppercase tracking-wide">Mode démo — votre code</p>
            <p className="font-display text-3xl font-bold text-brand-greenDeep tracking-[0.3em] mt-1">{demoCode}</p>
          </div>
        )}

        <input
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          inputMode="numeric"
          placeholder="______"
          data-testid="mfa-code-input"
          className="mt-5 w-full text-center text-2xl tracking-[0.5em] font-semibold px-4 py-3 rounded-xl border border-brand-soft outline-none focus:border-brand-lime text-brand-greenDeep"
        />
        <button onClick={verify} disabled={busy} className="mt-4 w-full py-3 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="mfa-verify-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Vérifier et continuer
        </button>
        <div className="flex items-center justify-between mt-4 text-sm">
          <button onClick={resend} className="text-brand-greenDeep font-medium hover:underline" data-testid="mfa-resend-btn">Renvoyer un code</button>
          <button onClick={logout} className="text-brand-green/50 hover:text-brand-greenDeep inline-flex items-center gap-1"><LogOut className="w-3.5 h-3.5" /> Se déconnecter</button>
        </div>
      </div>
    </div>
  );
}
